<template>
    <div class="venues-wrapper">
        <div class="search-result-container">
            <div
                id="preloader"
                class="preloader"
                :class="{ 'd-none': load, 'd-block': !load }"
            ></div>
            <div class="search-title-container">
                <p class="search-title">Venues</p>
                <hr />
            </div>
            <div v-if="!filteredVenues.length && load" class="search-result-empty">
                <p>Your search got no hits. Try removing some of the filters.</p>
            </div>
            <div v-if="filteredVenues.length && load" class="search-container">
                <Venue
                    v-for="(user, indx) in filteredVenues"
                    :key="indx"
                    :user="user"
                    :max-width="'336px'"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import { useAuth } from '@/composables/auth/useAuth'
    import Venue from '../search-result-venue/Venue.vue'

    const URLS = {
        redirect: {
            booking: '/booking-manager',
            venue: '/venues'
        },
        xhr: {
            fetch: {
                checkAuth: '/api/check-authorization',
                user: '/api/profile/v1/settings/user'
            }
        }
    }

    export default {
        name: 'venuesList',
        components: {
            Venue
        },
        setup() {
            const { handleShowRegisterModal } = useAuth()
            return {
                handleShowRegisterModal
            }
        },
        data: () => ({
            authed: false,
            userInfo: {},
            searchParams: {},
            defaultSearchParams: {
                location: '',
                city: '',
                lat: '',
                lon: '',
                search: '',
                date: ''
            },
            currentLocation: '',
            currentPage: 1,
            records: [],
            perPage: 10,
            venues: [],
            filterResult: [],
            mode: 'searchResults',
            load: false,
            contactId: null
        }),
        methods: {
            redirectToBookingFlow() {
                window.open(`${URLS.redirect.booking}/#referred-from-venues-page`, '_blank')
            },
            redirectToVenue(venue) {
                window.open(`${URLS.redirect.venue}/${venue.slug}`, '_blank')
            },
            async getVenuesList() {
                try {
                    const response = await axios.get('/api/search/venues', {
                        params: this.searchParams
                    })
                    this.filterResult = response.data.result
                    this.currentLocation = response.data.location.location
                    localStorage.setItem('currentLocation', this.currentLocation)
                    this.load = true
                } catch (error) {
                    notification('error', error.response.data.errors.message)
                }
            },
            populateSearchParams() {
                let params = new URL(window.location).searchParams

                this.searchParams = {
                    location: params.get('location') ?? this.defaultSearchParams.location,
                    city: params.get('city') ?? this.defaultSearchParams.city,
                    lat: params.get('lat') ?? this.defaultSearchParams.lat,
                    lon: params.get('lon') ?? this.defaultSearchParams.lon,
                    search: params.get('search') ?? this.defaultSearchParams.search,
                    date: params.get('date') ?? this.defaultSearchParams.date
                }
            },
            handlePageChange(page) {
                this.currentPage = page
            },
            async fetchUserInfo() {
                const response = await axios.get(URLS.xhr.fetch.user)

                return response.data.data[0]
            },
            async checkAuthorization() {
                try {
                    const resp = await axios.get(URLS.xhr.fetch.checkAuth)

                    if (resp?.data?.isAuthorized) {
                        this.authed = true
                    }
                } catch {
                    this.authed = false
                }
            }
        },
        computed: {
            filteredVenues() {
                return this.filterResult
            }
        },
        async created() {
            this.populateSearchParams()
            this.venuesList = JSON.parse(localStorage.getItem('venuesList'))
            this.venuesList = await this.getVenuesList()

            await this.checkAuthorization()
            if (this.authed) {
                this.userInfo = await this.fetchUserInfo()
            }
        },
        beforeDestroy() {
            localStorage.removeItem('venuesList')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';

    .venues-wrapper {
        @include flex-col;
        align-items: center;
        gap: 64px;
        background: $black;
        padding-bottom: 65px;
        min-height: 100vh;

        @media (max-width: $mobile) {
            min-height: revert;
        }

        .search-result-container {
            @include flex-col;
            align-items: center;
            gap: 20px;
            width: 100%;
            max-width: 1070px;

            .search-title-container {
                @include flex-start;
                @include flex-col;
                width: 100%;

                hr {
                    background: $grey;
                    width: 100%;
                }

                .search-title {
                    @include page-headline;
                }

                @media (max-width: $mobile) {
                    max-width: 336px;
                    padding: 0px;
                }
            }

            .search-result-empty {
                width: 100%;
                p {
                    @include base-font;
                    color: $lighter-grey;
                    line-height: 120%;
                    letter-spacing: -0.52px;
                }
            }

            .search-container {
                @include flex-row;
                @include flex-start;
                gap: 20px;
                flex-wrap: wrap;
                width: 100%;

                @media (max-width: $mobile) {
                    padding: 16px;
                    justify-content: center;
                }
            }
        }
    }
</style>
